// const defaultColor = '#043158';
const defaultColor = '#191919';

const themeStore = {
  namespaced: true,
  state() {
    return {
      themeColor: defaultColor,
    };
  },
  mutations: {
    setThemeColor(state, color) {
      state.themeColor = color;
    },
  },
  actions: {
    updateThemeColor({ commit }, color = defaultColor) {
      console.log('updateThemeColor', color);
      // 메타태그 업데이트
      const themeColorMeta = document.querySelector('meta[name="theme-color"]');
      if (themeColorMeta) themeColorMeta.setAttribute('content', color);
      // 헤더 색상 등록
      document.documentElement.style.setProperty('--header-color', color);

      commit('setThemeColor', color);
    },
  },
};

export default themeStore;
